import { render, staticRenderFns } from "./ExpireSabbatical.vue?vue&type=template&id=8a8ae7c0&scoped=true&"
import script from "./ExpireSabbatical.vue?vue&type=script&lang=js&"
export * from "./ExpireSabbatical.vue?vue&type=script&lang=js&"
import style0 from "./ExpireSabbatical.vue?vue&type=style&index=0&id=8a8ae7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8ae7c0",
  null
  
)

export default component.exports